import { RoleControlledActionConfiguration } from '@/types';

export const roleConfig: RoleControlledActionConfiguration = {
  refundOrder: {
    owner: { restricted: false, hidden: false },
    admin: { restricted: false, hidden: false },
    customer_care: { restricted: false, hidden: false },
    sales_manager: { restricted: false, hidden: false },
    sales_representative: { restricted: true, hidden: false },
    support_specialist: { restricted: false, hidden: false },
    view_only: { restricted: true, hidden: false },
  },
  exportOrders: {
    owner: { restricted: false, hidden: false },
    admin: { restricted: false, hidden: false },
    customer_care: { restricted: false, hidden: false },
    sales_manager: { restricted: true, hidden: false },
    sales_representative: { restricted: true, hidden: false },
    support_specialist: { restricted: true, hidden: false },
    view_only: { restricted: false, hidden: false },
  },
  cancelOrders: {
    owner: { restricted: false, hidden: false },
    admin: { restricted: false, hidden: false },
    customer_care: { restricted: false, hidden: false },
    sales_manager: { restricted: false, hidden: false },
    sales_representative: { restricted: true, hidden: false },
    support_specialist: { restricted: false, hidden: false },
    view_only: { restricted: true, hidden: false },
  },
};
